import { fetchWrapper } from "../utils/fetch-wrapper";

const parcellesService = {
  UpdateUnitesFonciere,
  getAllUnitesFonciere,
  DeleteUnitesFonciere,
  PostUnitesFonciere,
  getAll,
  getById,
  getByUuid,
  post,
  update,
  delete: _delete,
};

function getAll(env_client_id: any = "") {
  const queryParams: Record<string, any> = {};

  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }
  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");

  return fetchWrapper.get(`parcelles/?${queryString}`);
}

function getById(id) {
  return fetchWrapper.get(`parcelles/${id}`);
}

function getByUuid(uuid) {
  return fetchWrapper.get(`parcelles/${uuid}`);
}

function post(data) {
  return fetchWrapper.post("parcelles/", data);
}

function update(id, params) {
  return fetchWrapper.put(`parcelles/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`parcelles/${id}`);
}

function UpdateUnitesFonciere(id, params) {
  return fetchWrapper.put(`parcelles/UnitesFonciere/${id}`, params);
}

function PostUnitesFonciere(data) {
  return fetchWrapper.post(`parcelles/UnitesFonciere/`, data);
}

function DeleteUnitesFonciere(id) {
  return fetchWrapper.delete(`parcelles/UnitesFonciere/${id}`);
}

function getAllUnitesFonciere(env_client_id: any = "") {
  const queryParams: Record<string, any> = {};

  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }
  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");

  return fetchWrapper.get(`parcelles/UnitesFonciere/?${queryString}`);
}

export default parcellesService;
